import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import TextForm from './JurisprudenciaForm';
import { TextFormValues } from '../../types/Text.types';
import { showToast } from '../../components/Toast/showToast';
import { jurisprudenciaService } from '../../api/services';
import { JurisprudenciaFormValues } from '../../types/Jurisprudencia.types';
import JurisprudenciaForm from './JurisprudenciaForm';

const CreateJurisprudencia = () => {
  const navigate = useNavigate();
  const navigateToListTexts = useCallback(() => {
    navigate('/jurisprudencias');
  }, []);

  const handleSubmit = useCallback(async (data: JurisprudenciaFormValues) => {
    console.log(data);
    const successfullyCreated = await jurisprudenciaService.create({
      ...data,
    });
    if (successfullyCreated) {
      showToast({
        type: 'success',
        text: 'Sucesso ao cadastrar texto.',
      });
      navigateToListTexts();
    }
  }, []);

  return (
    <>
      <JurisprudenciaForm type="create" onSubmit={handleSubmit} onCancel={navigateToListTexts} />
    </>
  );
};

export default CreateJurisprudencia;
